<template>
  <a-button :size="size" :type="type" v-if="showUpgrade(config_type)" @click="onUpgradeClick">{{
    $t('sheng-ji-quan-yi')
  }}</a-button>
  <slot v-else></slot>
</template>
<script lang="ts" setup>
import { useUpgrade } from '@rendora/common/features/upgrade-badge/useUpgrade';
import { ASSET_TYPE } from '@rendora/common/types/enums';
import type { ButtonType } from 'ant-design-vue/es/button';
import type { SizeType } from 'ant-design-vue/es/config-provider';

const { showUpgrade, onUpgrade } = useUpgrade();
const emits = defineEmits(['cancel']);

const props = withDefaults(
  defineProps<{
    type?: ButtonType;
    size?: SizeType;
    config_type?: number;
  }>(),
  {
    config_type: ASSET_TYPE.COMMON,
  },
);

const onUpgradeClick = () => {
  emits('cancel');
  onUpgrade(props.config_type);
};
</script>

<!-- <style lang="scss" scoped></style> -->
